// Module
var code = "<a\n    ng-href=\"http://{{$parent.row['phrase'] || $parent.row['value']}}\"\n    ng-bind=\"$parent.row['phrase'] || $parent.row['value']\"\n    target = '_blank'>\n</a>";
// Exports
module.exports = code;